import React, { useCallback, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { eAlertsCoreAPIEndpoint, ENDPOINTS } from '../../api';
import jwt_decode from 'jwt-decode';
import jwt from 'jwt-decode';

export default function AuthProcessing() {
  let history = useHistory();
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const emailToken = encodeURIComponent(searchParams.get('token'));
  const email = encodeURIComponent(searchParams.get('email'));
  const parcelNumber = searchParams.get('parcelnumber')
    ? searchParams.get('parcelnumber')
    : '';

  const getToken = useCallback(async () => {
    await eAlertsCoreAPIEndpoint(ENDPOINTS.ACCOUNT)
      .verifyEmailToken(email, emailToken)
      .then((response) => {
        const decoded = jwt_decode(response.data.token);
        //dotnet datetime.utcnow method returns a less precise timestamp than JS. multiply by 1000 to compensate.
        localStorage.setItem('timeout', decoded.exp * 1000);
        localStorage.setItem('token', response.data.token);
        if (parcelNumber) {
          localStorage.setItem('parcelNumber', parcelNumber);
        }
        history.push(`/loading/${jwt(response.data.token).id}`);
      })
      .catch((error) => {
        if (error) {
          history.push(`/login/?parcelnumber=${parcelNumber}`);
        }
      });
  }, [email, emailToken, parcelNumber, history]);

  useEffect(() => {
    getToken();
  }, [getToken]);

  return (
    <>
      <br />
      <br />
    </>
  );
}
